(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["deal-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  // Modal handlers
  document.querySelectorAll('[data-modal]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const modal = document.getElementById(btn.dataset.modal);
      modal?.classList.add('active');
    });
  });
  
  document.querySelectorAll('.deal-modal-close, .deal-modal').forEach(el => {
    el.addEventListener('click', e => {
      if (e.target === el) {
        const modal = e.target.classList.contains('deal-modal') ? e.target : document.getElementById(el.dataset.close);
        modal?.classList.remove('active');
      }
    });
  });

  // Buy once handler - adds at full price when clicking "Buy Once" text
  document.querySelectorAll('.deal-buy-once-link').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      
      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ 
          id: variantId, 
          quantity: 1
        })
      })
      .then(res => res.json())
      .then(data => {
        window.locatio
      })
      .catch(err => {
        console.error('Error adding to cart:', err);
        btn.disabled = false;
        btn.textContent = originalText;
        alert('Error adding to cart. Please try again.');
      });
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
